import { Validator } from '@ContextLogic/lego/toolkit/forms/validators';

import { i18n, ni18n } from 'utils/i18n';

export class CharacterLengthValidator extends Validator {
  minimum: number | null | undefined;

  maximum: number | null | undefined;

  constructor({
    minimum,
    maximum,
    customMessage,
    allowBlank,
  }: {
    customMessage?: string | null | undefined;
    allowBlank?: boolean;
    minimum?: number;
    maximum?: number;
  } = {}) {
    super({ customMessage, allowBlank });
    if (minimum != null && maximum != null) {
      if (minimum > maximum) {
        throw Error(
          `minimum (${minimum}) cannot be larger than maximum (${maximum})`,
        );
      }
    }
    this.minimum = minimum;
    this.maximum = maximum;
  }

  async validateText(text: string) {
    const value = text.trim();
    const { maximum, minimum } = this;
    if (minimum != null && value.length < minimum) {
      return this.errorMessage();
    }

    if (maximum != null && value.length > maximum) {
      return this.errorMessage();
    }

    return null;
  }

  errorMessage(): string | null | undefined {
    const { customMessage, maximum, minimum } = this;
    if (maximum != null && minimum != null) {
      if (customMessage) {
        return customMessage;
      }

      if (maximum === minimum) {
        return ni18n(
          maximum,
          'This field should only be 1 character long',
          'This field should be {%1=number of characters} characters long',
        );
      }
      return i18n(
        'This field must be {%1=min number of characters} - {%2=max number of characters} characters long',
        minimum,
        maximum,
      );
    }

    if (maximum != null) {
      if (customMessage) {
        return customMessage;
      }
      return i18n(
        'This field cannot be longer than {%1=max number of characters} characters',
        maximum,
      );
    }

    if (minimum != null) {
      if (customMessage) {
        return customMessage;
      }
      return i18n(
        'This field must be at least {%1=min number of characters} characters',
        minimum,
      );
    }

    return null;
  }
}

export const isValidEmailAddress = (emailAddress: string) => {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    emailAddress.toLowerCase(),
  );
};
